module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAAXNSR0IArs4c6QAAARZJREFUOBHNkz0KwkAQhRMVtRMrK20sbMXCUvAAViJ4DltBgr0g3sPKC9jYewQLa7GwUPDvvbhDls1mE60c+LKbNzsvm83E9+JRhtSKy07lYMsOIL6+ZFqwOSntjHHvyDPVBHVOXEY06XORIxbITZjPgTG4aqwxZ/SA6LNQcVy4owoogTt4gCe4AUYR+CAAjPlniF+5I4kVJvxiOkeV5OEHIHFnupGqsQ4jqE6zrEZLGPG85DW75uN4Rlki/MRqIc1qZlHajhooYKGwNQ3kPs1I1qWO/2eU9bDNV2P3s3HzkvjVSOr5J5DTr0ZDFG/EjaNuxO7t6EnLvG3RQkk3YtPpjZdUY9XZaFUQa3nr6kjcYXqJbj3vDU2vL4FVznNnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/dropdown_duplicate.png
// module id = ./src/_asset/sources/assets/images/dropdown_duplicate.png
// module chunks = main